import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { DepartureCommittedSearch } from '~/components/Cruises/components/shared/DepartureGridConfig';

import departureService from '~/services/cruises/DepartureService';

import { departureQueryKeys } from './departureQueryKeys';

export const DEPARTURE_PAGE_SIZE = 25;

export function useGetDepartures(committedSearch: DepartureCommittedSearch | null, page: number) {
  return useQuery({
    queryKey: departureQueryKeys.list(committedSearch, page),
    queryFn: () => {
      if (!committedSearch) {
        throw new Error('committedSearch is required');
      }
      return departureService.listWithPagination({
        vendorId: committedSearch.vendorId,
        name: committedSearch.name || undefined,
        shipName: committedSearch.shipName || undefined,
        departureDateStart: committedSearch.departureDateStart || undefined,
        departureDateEnd: committedSearch.departureDateEnd || undefined,
        sailingDurationMin: committedSearch.sailingDurationMin ? Number(committedSearch.sailingDurationMin) : undefined,
        sailingDurationMax: committedSearch.sailingDurationMax ? Number(committedSearch.sailingDurationMax) : undefined,
        status: committedSearch.status || undefined,
        offerId: committedSearch.offerId || undefined,
        sailingExternalId: committedSearch.sailingExternalId ? Number(committedSearch.sailingExternalId) : undefined,
        shipExternalId: committedSearch.shipExternalId ? Number(committedSearch.shipExternalId) : undefined,
        departurePortExternalIds: committedSearch.departurePortExternalIds.length
          ? committedSearch.departurePortExternalIds
          : undefined,
        skip: page * DEPARTURE_PAGE_SIZE,
        take: DEPARTURE_PAGE_SIZE,
      });
    },
    enabled: !!committedSearch,
    placeholderData: keepPreviousData,
  });
}
